export class WorkOrderProposalAddParametersDto {
    communityVendorIds: Array<number>;
    locationVendorIds: Array<number>;
    temporaryVendorIds: Array<number>;
    communityId: number;
    workOrderId: number;
}
